/**
 * contact.js
 * import OverlayTrigger from react bootstrap for tooltips
 * import Tooltip from react bootstrap for tooltips
 * import Button is the button field from react bootstrap
 * import Row and Col from react bootstrap for organizing display
 */
import React from "react";
import axios from "axios";
import Button from "react-bootstrap/Button";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import '../../style/creationstyle.css';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
/** 
* takes in all the contacts and displays the contacts name and email
* also sends a delete request to backend with the contact ID to delete
* @params contact = contact id
* @params getContact = function for get all current contacts
* @params editContact = function for editing contacts
*/
function Contact({contact, getContact, editContact}) {

    const toolTipDelete = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            Delete {contact.name}
        </Tooltip>
    );

    const toolTipEdit = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            Edit {contact.name}
        </Tooltip>
    )
    
    /**
     * deleteContact()
     * deletes a contact from the user's contact list
     * then gets all current contacts
     */
    async function deleteContact() {
        await axios.delete(`https://link2rsvp.herokuapp.com/contact/${contact._id}`);

        getContact();
    }


    return (
        <div className="contact">
            <Row id="contact-row">
                <Col>
            {contact.name && <h6>{contact.name}</h6>}
            {contact.email && <p>{contact.email}</p>}
                </Col>
                <Col id="second-col">
                <span id="btn-span">
                    <OverlayTrigger
                    placement="top"
                    overlay={toolTipDelete}
                    >
                <Button variant="dark" onClick={deleteContact} className="editing" style={{backgroundColor: "black", color: "white", fontSize: "17pt"}}>&times;</Button>
                </OverlayTrigger>
                <OverlayTrigger
                placement="top"
                overlay={toolTipEdit}
                >
                <Button variant="secondary" onClick={() => {editContact(contact);}} className="editing" style={{backgroundColor: "rgb(138,14,50)", color: "white", fontSize: "16pt"}}>&#9998;</Button>
                </OverlayTrigger>
                </span>
                </Col>
            </Row>
        </div>
        );
}

export default Contact;